import type { LottoCredentialStatusDisplay } from '../../../../types/features/storeDetails/overview';

const LOTTO_CREDENTIAL_STATUS_DISPLAY: Record<string, LottoCredentialStatusDisplay> = {
    active: {
        iconName: 'fluent:checkmark-circle-24-filled',
        label: 'Password Active',
        tone: 'success',
    },
    expired: {
        iconName: 'fluent:warning-24-filled',
        label: 'Password Expired',
        tone: 'danger',
    },
};

const formatUnknownPasswordStatus = (status: string): string =>
    status
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ');

export const getLottoCredentialStatusDisplay = (
    status?: string | null,
): LottoCredentialStatusDisplay | null => {
    const normalizedStatus = status?.trim().toLowerCase();

    if (!normalizedStatus) {
        return null;
    }

    const fallbackStatusLabel = formatUnknownPasswordStatus(normalizedStatus);

    if (!fallbackStatusLabel) {
        return null;
    }

    return LOTTO_CREDENTIAL_STATUS_DISPLAY[normalizedStatus] ?? {
        iconName: 'fluent:info-24-filled',
        label: `Password ${fallbackStatusLabel}`,
        tone: 'neutral',
    };
};
